import { useAppSelector } from 'redux/hooks';
import { authSelectors } from 'redux/modules/Authorization';

export const useAPlayerStatus = () =>
  useAppSelector(authSelectors.getAPlayerStatus);
